import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <h1>Translate Documents with Local Dialects</h1>
          <p>Our AI-powered service accurately translates documents while preserving local dialects and cultural nuances.</p>
          <div className="hero-buttons">
            <Link to="/translate" className="btn btn-primary">Get Started</Link>
            <Link to="/register" className="btn btn-secondary">Sign Up Free</Link>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>Powerful Translation Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>Dialect Support</h3>
              <p>Support for hundreds of local dialects and regional variations</p>
            </div>
            <div className="feature-card">
              <h3>Document Processing</h3>
              <p>Upload PDF, Word, or text documents for seamless translation</p>
            </div>
            <div className="feature-card">
              <h3>AI-Powered</h3>
              <p>Advanced AI models trained on local linguistic patterns</p>
            </div>
            <div className="feature-card">
              <h3>Secure</h3>
              <p>Enterprise-grade security for your sensitive documents</p>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <div className="container">
          <h2>How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Upload Document</h3>
              <p>Upload your document in any supported format</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Select Dialect</h3>
              <p>Choose your target dialect and language</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Get Translated</h3>
              <p>Receive your dialect-accurate translation</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;